export default {
  usuarios: [],
}
